// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__27UFt","selects":"Documents_selects__1eln8"};